<app-review-form-header>
  <div title>
    <span class="text-xl font-bold" data-testid="assignment-title">{{ title() }}</span>
  </div>
  <div actions class="flex items-center gap-2">
    <app-pan-button color="primary" icon="arrow_back" (click)="goToDashboard()">Back</app-pan-button>

    <app-pan-button
      color="primary"
      icon="check"
      (click)="reviewModal.show()"
      [state]="isSubmitting() ? 'loading' : 'default'"
      [disabled]="!assignment() || isSubmitting() || !!assignmentError()"
      data-testid="completeReview"
    >
      Complete Review
    </app-pan-button>

    <app-review-report-problem [reviewId]="assignmentId()"></app-review-report-problem>

    @if (assignment()) {
      <app-review-timer [reviewId]="assignmentId()"></app-review-timer>
    }
  </div>
</app-review-form-header>

<app-pan-modal [shouldBodyScroll]="true" #reviewModal [topLevel]="false" size="lg">
  <div header>Submit review</div>

  <div body>
    @if (formTemplate; as tpl) {
      <ng-container [ngTemplateOutlet]="tpl"></ng-container>
    }
    <app-review-submission-failed-modal #failedModal [errorMessage]="submitFailureError()"></app-review-submission-failed-modal>
  </div>

  <div footer>
    <button
      panButton
      panModalClose
      color="primary"
      (click)="submit()"
      [disabled]="isSubmitting() || !reviewFormService.isFormSubmittable()"
      [state]="isSubmitting() ? 'loading' : 'default'"
      data-testid="submitReview"
    >
      Submit
    </button>
    <app-pan-button panModalClose>Cancel</app-pan-button>
  </div>
</app-pan-modal>

<app-pan-modal #submittedModal size="sm">
  <div header>Incident submitted 🎉</div>
  <div body class="text-center">
    <app-pan-form-control class="flex w-full">
      <app-pan-floating-label>Review ID</app-pan-floating-label>
      <input panInput type="text" [value]="assignmentIdShort()" readonly />
      <app-pan-button icon="content_copy" fill="clear" (click)="copyReviewId()"></app-pan-button>
    </app-pan-form-control>
  </div>
  <div footer class="flex gap-2">
    <app-pan-button (click)="goToDashboard()" [disabled]="isCreatingAssignment()">Back to dashboard</app-pan-button>
    @if (allowAdditionalSubmissions()) {
      <app-pan-button
        color="primary"
        (click)="createAdditionalAssignment()"
        [disabled]="isCreatingAssignment()"
        [state]="isCreatingAssignment() ? 'loading' : 'default'"
      >
        Report another incident
      </app-pan-button>
    }
  </div>
</app-pan-modal>

@if (lpReviewUrl()) {
  <app-pan-inline-alert type="primary" class="m-2">
    Try out the new review experience!
    <a panButton icon="open_in_new" [href]="lpReviewUrl()" target="_blank" rel="noopener noreferrer" data-testid="openInLp">Open in LP</a>
  </app-pan-inline-alert>
}

@if (isLoading()) {
  <app-pan-blank-slate> <app-pan-spinner></app-pan-spinner> &nbsp;Loading... </app-pan-blank-slate>
}

@if (isCompleted()) {
  <app-pan-inline-alert type="info" class="m-2"> This assignment has already been completed. </app-pan-inline-alert>
}

@if (isExpired() && !isCompleted()) {
  <app-pan-inline-alert type="danger" class="m-2">
    This assignment has expired. You can report a problem to end this assignment, or wait for it to be automatically archived (~15 minutes
    from expiration)
  </app-pan-inline-alert>
}

@if (errorMessage()) {
  <app-pan-inline-alert type="danger" class="m-2">
    {{ errorMessage() }}
  </app-pan-inline-alert>
}

@if (assignmentError()) {
  <app-pan-inline-alert type="danger" class="m-2">
    {{ assignmentError() }}
  </app-pan-inline-alert>
}

@switch (incidentType()) {
  @case (ReviewSubjectType.Cancellation) {
    <app-transaction-incident-form
      [locationTimezone]="assignment()?.location_timezone"
      (contextReady)="onContextReady($event)"
      (formRefReady)="formTemplate = $event"
    />
  }
  @case (ReviewSubjectType.Underringing) {
    <app-transaction-incident-form
      [locationTimezone]="assignment()?.location_timezone"
      (contextReady)="onContextReady($event)"
      (formRefReady)="formTemplate = $event"
    />
  }
  @case (ReviewSubjectType.Sideloaded) {
    <app-sideloaded-incident-form
      [locationTimezone]="assignment()?.location_timezone"
      (contextReady)="onContextReady($event)"
      (contextError)="onContextError($event)"
      (formRefReady)="formTemplate = $event"
    />
  }
  @case (ReviewSubjectType.Deepdive) {
    <app-sideloaded-incident-form
      [locationTimezone]="assignment()?.location_timezone"
      (contextReady)="onContextReady($event)"
      (contextError)="onContextError($event)"
      (formRefReady)="formTemplate = $event"
    />
  }
  @case (ReviewSubjectType.Grocery) {
    <app-grocery-incident-form
      [locationTimezone]="assignment()?.location_timezone"
      (contextReady)="onContextReady($event)"
      (contextError)="onContextError($event)"
      (formRefReady)="formTemplate = $event"
    />
  }
  @case (ReviewSubjectType.Walkout) {
    <app-walkout-incident-form
      [locationTimezone]="assignment()?.location_timezone"
      (contextReady)="onContextReady($event)"
      (formRefReady)="formTemplate = $event"
    />
  }
}
